<template>
  <div>
    <KTCard ref="preview" v-bind:title="'Add new'">
      <template v-slot:title>
        <h3 class="card-label">
          <router-link :to="{ name: 'list-ai-invoices' }">{{
            $t("MENU.ITEM.EXP.AI_INVOICES")
          }}</router-link>
          <i class="mr-2"></i>
          <small class="">{{ $t("LABELS.ADD_NEW") }}</small>
        </h3>
      </template>
      <template v-slot:toolbar>
        <div class="example-tools justify-content-center">
          <BackButton></BackButton>
          <SaveButtonDropdown
            :defaultAction="'exit'"
            :isLoading="isLoadingAiInvoice"
            v-on:save="onSave($event)"
          ></SaveButtonDropdown>
        </div>
      </template>
      <template v-slot:body>
        <AiInvoiceForm ref="AiInvoiceForm" :form="form"></AiInvoiceForm>

        <v-overlay :value="isLoadingAiInvoice">
          <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
      </template>
      <template v-slot:foot>
        <div
          v-show="_.size(errors) > 0"
          role="alert"
          class="alert alert-danger"
        >
          <div class="alert-text" v-for="(error, i) in errors" :key="i">
            {{ error[0] }}
          </div>
        </div>
      </template>
      <template v-slot:toolbarfoot>
        <div class="example-tools justify-content-center">
          <BackButton></BackButton>
          <SaveButtonDropdown
            :defaultAction="'exit'"
            :isLoading="isLoadingAiInvoice"
            v-on:save="onSave($event)"
          ></SaveButtonDropdown>
        </div>
      </template>
    </KTCard>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { SAVE_AI_INVOICE } from "@/modules/ai-invoices/store/ai-invoices.module";

import SaveButtonDropdown from "@/view/content/forms/components/SaveButtonDropdown.vue";
import BackButton from "@/core/components/BackButton.vue";

import KTCard from "@/view/content/Card.vue";
import AiInvoiceForm from "../components/AiInvoiceForm.vue";
import { mapGetters } from "vuex";

export default {
  name: "AiInvoiceAdd",
  components: {
    KTCard,
    SaveButtonDropdown,
    BackButton,
    AiInvoiceForm
  },
  data() {
    return {
      errors: {},
      form: {
        invoiceNumber: null,
        date: null,
        supplierName: null,
        supplierVat: null,
        supplierMol: null,
        supplierAddress: null,
        buyerName: null,
        buyerVat: null,
        buyerMol: null,
        buyerAddress: null,
        totalAmount: 0,
        taxAmount: 0,
        currency: "BGN",
        paymentDeadlineDate: null,
        isProcessed: false,
        aiSupplierId: null,
        aiBuyerId: null,
        isTotalCorrect: true,
        aiInvoiceTypeId: null
      }
    };
  },
  computed: {
    ...mapGetters(["isLoadingAiInvoice"])
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      {
        title: this.$i18n.t("MENU.ITEM.EXP.AI_INVOICES"),
        route: { name: "list-ai-invoices" }
      },
      { title: this.$i18n.t("LABELS.ADD_NEW") }
    ]);
  },
  methods: {
    onSave(next) {
      let vm = this;
      this.$refs.AiInvoiceForm.$v.form.$touch();
      if (this.$refs.AiInvoiceForm.$v.form.$anyError) {
        vm.$notify({
          group: "notify",
          type: "error",
          title: "<i class='flaticon-close'></i> Warning",
          text: "Please fill all required fields correctly"
        });
        return;
      }
      this.$store
        .dispatch(SAVE_AI_INVOICE, this.form)
        .then(data => {
          vm.errors = {};
          let itemEdit = data.data;
          vm.$notify({
            group: "notify",
            type: "success",
            title: "<i class='flaticon2-checkmark'></i> Success",
            text: data.message
          });

          if (next == "continue") {
            this.$router.push({
              name: "list-ai-invoices"
            });
          }
          if (next == "new") {
            this.$router.push({ name: "add-ai-invoices" });
          }
          if (next == "exit") {
            this.$router.push({ name: "list-ai-invoices" });
          }
        })
        .catch(response => {
          vm.errors = response.data.errors;
          vm.$notify({
            group: "notify",
            type: "error",
            title: this.$t("ALERTS.ERROR"),
            text: response.data.message
          });
        });
    }
  }
};
</script>
